import * as React from "react";
import { useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Box, Dialog } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  loginApi,
  RegisterStepOneApi,
  RegisterStepTwoApi,
  setPasswordApi,
  setReferralCodeApi,
  loginCodeStep1Api,
  loginCodeStep2Api,
} from "../../services/authApi";
import FormalLogin from "./FormalLogin";
import RegisterStep1 from "./RegisterStep1";
import RegisterStep2 from "./RegisterStep2";
import RegisterStep3 from "./RegisterStep3";
import SetReferralCode from "./SetReferralCode";
import ForgetPassword from "./ForgetPassword";
import ForgetPasswordStep2 from "./ForgetPasswordStep2";
import { customToastify, checkErrorMessage, checkResponseData } from "../../components/pages/utils/utilsFunctions"
import GmailPopUp from "./GmailPopUp"

export default function SingInForum(props) {
  const { handleShowLoginForm } = props;
  const [showingForm, setShowingForm] = useState("FormalLogin");
  const [signInBox, setSignInBox] = useState(true);
  const [userType, seUserType] = useState(["user"]);
  const [formalLoginValues, setFormalLoginValues] = useState({
    loginInfo: "",
    password: "",
  });
  const handleCloseSignInBox = () => {
    setSignInBox(false)
  }
  const handleUserType = () => {
    seUserType(["user"])
  }
  const [registerValues, setRegisterValues] = useState({
    phoneNumber: "",
    countryName: "",
    confirmCode: "",
    registerCode: "",
  });
  const [forgetPasswordValues, setForgetPasswordValues] = useState({
    phoneNumber: "",
    confirmCode: "",
  });
  const [disableButton, setDisableButton] = useState(false);
  const [userName, setUserName] = useState("");

  const handleShowingFormsValues = (selectedForm) => {
    setShowingForm(selectedForm);
  };
  const ManageShowingForms = (selected) => {
    switch (selected) {
      case "GmailPopUp":
        return (
          <GmailPopUp
            handleShowingFormsValues={handleShowingFormsValues}
          />
        );
      case "FormalLogin":
        return (
          <FormalLogin
            formalLoginValues={formalLoginValues}
            handleFormalLoginValue={handleFormalLoginValue}
            handleFormalLoginSubmit={handleFormalLoginSubmit}
            handleShowingFormsValues={handleShowingFormsValues}
            disableButton={disableButton}
            customToastify={customToastify}
          />
        );
      case "RegisterStep1":
        return (
          <RegisterStep1
            disableButton={disableButton}
            handleRegisterValues={handleRegisterValues}
            handleRegisterStep1Submit={handleRegisterStep1Submit}
            handleShowingFormsValues={handleShowingFormsValues}
            registerValues={registerValues}
            customToastify={customToastify}
          />
        );
      case "RegisterStep2":
        return (
          <RegisterStep2
            disableButton={disableButton}
            handleRegisterValues={handleRegisterValues}
            handleRegisterStep1Submit={handleRegisterStep1Submit}
            handleRegisterStep2Submit={handleRegisterStep2Submit}
            handleShowingFormsValues={handleShowingFormsValues}
            registerValues={registerValues}
            customToastify={customToastify}
          />
        );
      case "RegisterStep3":
        return (
          <RegisterStep3
            disableButton={disableButton}
            userName={userName}
            handleRegisterStep3Submit={handleRegisterStep3Submit}
            handleShowingFormsValues={handleShowingFormsValues}
            customToastify={customToastify}
          />
        );
      case "SetReferralCode":
        return (
          <SetReferralCode
            disableButton={disableButton}
            handleSetReferralCodeSubmit={handleSetReferralCodeSubmit}
          />
        );
      case "ForgetPassword":
        return (
          <ForgetPassword
            disableButton={disableButton}
            handleForgetPasswordValues={handleForgetPasswordValues}
            forgetPasswordValues={forgetPasswordValues}
            handleForgetPassword={handleForgetPassword}
            handleShowingFormsValues={handleShowingFormsValues}
            customToastify={customToastify}
          />
        );
      case "ForgetPasswordStep2":
        return (
          <ForgetPasswordStep2
            disableButton={disableButton}
            handleForgetPasswordValues={handleForgetPasswordValues}
            forgetPasswordValues={forgetPasswordValues}
            handleForgetPasswordStep2Submit={handleForgetPasswordStep2Submit}
            handleShowingFormsValues={handleShowingFormsValues}
            customToastify={customToastify}
          />
        );
      default:
        return "Error";
    }
  };

  const handleFormalLoginValue = (type, value) => {
    if (type == "loginInfo")
      setFormalLoginValues({ ...formalLoginValues, loginInfo: value });
    else if (type == "password")
      setFormalLoginValues({ ...formalLoginValues, password: value });
    else console.error("handleFormalLoginValue");
  };

  const handleRegisterValues = (type, value) => {
    if (type == "phoneNumber")
      setRegisterValues({ ...registerValues, phoneNumber: value });
    else if (type == "confirmCode")
      setRegisterValues({ ...registerValues, confirmCode: value });
    else if (type == "registerCode")
      setRegisterValues({ ...registerValues, registerCode: value });
    else if (type == "phoneNumberAndcountryName")
      setRegisterValues({ ...registerValues, ...{ phoneNumber: value[0], countryName: value[1] } });
    else console.error("handleRegisterValues");
  };
  const handleForgetPasswordValues = (type, value) => {
    if (type == "phoneNumber")
      setForgetPasswordValues({ ...forgetPasswordValues, phoneNumber: value });
    else if (type == "confirmCode")
      setForgetPasswordValues({ ...forgetPasswordValues, confirmCode: value });
    else console.error("handleForgetPasswordValues");
  };

  const handleFormalLoginSubmit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setDisableButton(true);
      const data = formalLoginValues;
      const response = await loginApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(response.data.token));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        handleUserType(resData["data"]["data"][0]["type_user"])
        setUserName(resData["data"]["data"][0]["userName"])
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setTimeout(() => {
          handleCloseSignInBox(false);
          handleShowLoginForm(true)
          let locationUrl = window.location.href.toLowerCase()
          if (locationUrl.indexOf("editprofileforum") > 0) {
            console.log("edit Profile")
          } else {
            window.location.replace("https://forum.umlang.com")
          }
        }, 1000)
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      // customToastify("error", errData["titles"]);
      console.error(error);
    }
  };

  const handleRegisterStep1Submit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setDisableButton(true);
      const data = { phoneNumber: registerValues.phoneNumber };
      const response = await RegisterStepOneApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        handleShowingFormsValues("RegisterStep2");
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        // setTimeout(() => {
        //   handleCloseSignInBox(false);
        // }, 1000)
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleRegisterStep2Submit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const registerCode = JSON.parse(localStorage.getItem("registerCode"));
      if (registerCode) handleRegisterValues("registerCode", registerCode);
      setDisableButton(true);
      const data = {
        phoneNumber: registerValues.phoneNumber,
        confirmCode: registerValues.confirmCode,
        registerCode,
      };
      const response = await RegisterStepTwoApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(response.data.token));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        handleUserType(resData["data"]["data"][0]["type_user"])
        setUserName(resData["data"]["data"][0]["userName"])
        handleShowingFormsValues("RegisterStep3");
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        handleShowLoginForm(true)
        window.location.replace("https://forum.umlang.com")
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleRegisterStep3Submit = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setDisableButton(true);
      const response = await setPasswordApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        handleShowingFormsValues("RegisterStep3");
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        if (resData["data"]["data"][0]["registerCode"])
          handleCloseSignInBox(false);
        else handleShowingFormsValues("SetReferralCode");
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }

      // customToastify("info", "پسورد با موفقیت ذخیره شد");
      // console.log("123", response);

    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleSetReferralCodeSubmit = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setDisableButton(true);
      const response = await setReferralCodeApi(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        setTimeout(() => {
          handleCloseSignInBox(false);
        }, 1000)
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleForgetPassword = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      const data = { phoneNumber: forgetPasswordValues.phoneNumber };

      setDisableButton(true);
      const response = await loginCodeStep1Api(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        handleShowingFormsValues("ForgetPasswordStep2");
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  const handleForgetPasswordStep2Submit = async () => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setDisableButton(true);
      const data = {
        phoneNumber: forgetPasswordValues.phoneNumber,
        confirmCode: forgetPasswordValues.confirmCode,
      };
      const response = await loginCodeStep2Api(data)
      setDisableButton(false);
      const resData = checkResponseData(response)
      if (resData["success"]) {
        localStorage.setItem("token", JSON.stringify(response.data.token));
        localStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));
        handleUserType(resData["data"]["data"][0]["type_user"])
        setUserName(resData["data"]["data"][0]["userName"])
        handleShowingFormsValues("RegisterStep3");
        // setUserName(resData["data"]["data"][0]["userName"])
        toast.update(toastMsg, { render: resData["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
      } else {
        toast.update(toastMsg, { render: resData["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      setDisableButton(false);
      const errData = checkErrorMessage(error)
      toast.update(toastMsg, { render: errData["titles"] || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });
      console.error(error);
    }
  };

  return (
    <Dialog variant="permanent" open={signInBox} onClose={handleCloseSignInBox}>
      <Container
        component="main"
        color="primary"
        maxWidth="xs"
        sx={{ borderRadius: 3, width: 250 }}
      >
        <CssBaseline />
        {ManageShowingForms(showingForm)}
      </Container>

    </Dialog>
  );
}
